import { useContext } from "react";
import { CategoryContext } from "../context/CategoryProvider";

export default function useCategory() {
  const { categories, setCategories } = useContext(CategoryContext);

  return {
    categories,
    setCategories,
  };
}
